/* eslint eqeqeq: off */
import React from "react";
import './index.css';
import Modal, {ModalAction, ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import Input from "../../../Components/Control/Input";
import Select from "../../../Components/Control/Select";
import {connect} from "react-redux";
import moment from "jalali-moment";
import Date from "../../../Components/Control/Date";
import Resource from "../../../Resource";
import PropTypes from 'prop-types';
import Separator from "../../../Components/Control/Separator";
import Label from "../../../Components/Control/Label";
import Radio from "../../../Components/Control/Radio";
import Check from "../../../Components/Control/Check";
import {updateBase} from "../../../Redux/Actions/base";
import {Tool} from "../../../App";
import ValidationSpot from "../../../Components/Control/ValidationSpot";
import ModalPrint from "../ModalPrint";
import {printerTemplate} from "../../../Printer";
import Notif from "../../../Components/Notif";
import Patient from "../../../Server/Patient";
import {SectionNormRequest} from '../../../Server/NormRequest';
import InputButton from '../../../Components/Control/InputButton';
import MyComponent from '../../../Components/MyComponent';

class ModalSectionNormInformalRequest extends MyComponent {
    constructor (props) {
        super(props);
        props.refer.current = this;

        this.state = {
            error: null,
            loading: null,
            provinces: [
                {id: '', text: '...', cities: []},
                ...props.base.provinceCities.map(item => {
                    return {
                        id: item.provinceId, text: item.provinceName, cities: (item.cities || []).map(item => {
                            return {id: item.cityId, text: item.cityName};
                        })
                    };
                })
            ],
            sections: [
                {id: '', text: '...'},
                ...props.base.hospitalSections.map(item => {
                    return {id: item.sectionId, text: item.sectionName};
                })
            ],
            bloodGroups: [
                {id: '', text: '...'},
                ...props.base.bloodGroups.map(item => {
                    return {id: item.id, text: item.name};
                })
            ],
            fields: {},
            history: []
        };

        this.ref = {
            modal: React.createRef(),
            modalPrint: React.createRef(),
            patientFirstName: React.createRef(),
            patientLastName: React.createRef(),
            patientFatherName: React.createRef(),
            patientBirthDate: React.createRef(),
            patientNationalCode: React.createRef(),
            patientGenderId: React.createRef(),
            patientProvinceId: React.createRef(),
            patientCityId: React.createRef(),
            sectionId: React.createRef(),
            patientFileCode: React.createRef(),
            products: React.createRef(),
            rbccount: React.createRef(),
            wbcount: React.createRef(),
            lrbccount: React.createRef(),
            ffpcount: React.createRef(),
            pediatricCount: React.createRef(),
            crycount: React.createRef(),
            washedRbccount: React.createRef(),
            cppcount: React.createRef(),
            otherProductsName: React.createRef(),
            otherProductsCount: React.createRef(),
            pltcount: React.createRef(),
            requestPurpose: React.createRef(),
            patientBloodGroupId: React.createRef(),
            insert: React.createRef(),
            update: React.createRef(),
            printLabel: React.createRef(),
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    validations = {
        patientFirstName: x => Boolean(!this.state.fields?.patientFileCode || x) || 'نام بیمار نمی‌تواند خالی باشد.',
        patientLastName: x => Boolean(!this.state.fields?.patientFileCode || x) || 'نام خانوادگی بیمار نمی‌تواند خالی باشد.',
        patientFatherName: x => Boolean(!this.state.fields?.patientFileCode || x) || 'نام پدر بیمار نمی‌تواند خالی باشد.',
        patientBirthDate: x => Boolean(!this.state.fields?.patientFileCode || x) || 'تاریخ تولد نمی‌تواند خالی باشد.',
        patientGenderId: x => Boolean(!this.state.fields?.patientFileCode || x) || 'جنسیت بیمار انتخاب نشده است.',
        patientProvinceId: x => Boolean(!this.state.fields?.patientFileCode || x[0]?.id) || 'استان انتخاب نشده است.',
        patientCityId: x => Boolean(!this.state.fields?.patientFileCode || x[0]?.id) || 'شهر انتخاب نشده است.',
        sectionId: x => Boolean(x[0]?.id) || 'بخش انتخاب نشده است.',
        patientFileCode: x => Boolean(x) || 'شماره پرونده بیمار وارد نشده است.',
        products: fields => {
            return Boolean(fields.rbccount) ||
                Boolean(fields.wbcount) ||
                Boolean(fields.lrbccount) ||
                Boolean(fields.ffpcount) ||
                Boolean(fields.pediatricCount) ||
                Boolean(fields.crycount) ||
                Boolean(fields.washedRbccount) ||
                Boolean(fields.cppcount) ||
                Boolean(fields.otherProductsCount) ||
                Boolean(fields.pltcount) ||
                'فرآورده‌ای انتخاب نشده است.';
        },
        rbccount: x => x === '' || x === undefined || x === false || x > 0 || 'تعداد وارد نشده است.',
        wbcount: x => x === '' || x === undefined || x === false || x > 0 || 'تعداد وارد نشده است.',
        lrbccount: x => x === '' || x === undefined || x === false || x > 0 || 'تعداد وارد نشده است.',
        ffpcount: x => x === '' || x === undefined || x === false || x > 0 || 'تعداد وارد نشده است.',
        pediatricCount: x => x === '' || x === undefined || x === false || x > 0 || 'تعداد وارد نشده است.',
        crycount: x => x === '' || x === undefined || x === false || x > 0 || 'تعداد وارد نشده است.',
        washedRbccount: x => x === '' || x === undefined || x === false || x > 0 || 'تعداد وارد نشده است.',
        cppcount: x => x === '' || x === undefined || x === false || x > 0 || 'تعداد وارد نشده است.',
        otherProductsName: x => {
            const count = this.state.fields.otherProductsCount;
            return count === '' || count === undefined || count === false || Boolean(x) || 'نام فرآورده وارد نشده است.';
        },
        otherProductsCount: x => x === '' || x === undefined || x === false || x > 0 || 'تعداد وارد نشده است.',
        pltcount: x => x === '' || x === undefined || x === false || x > 0 || 'تعداد وارد نشده است.',
        requestPurpose: x => Boolean(x) || 'هدف درخواست انتخاب نشده است.',
        patientBloodGroupId: x => Boolean(x[0]?.id) || 'گروه خون نمونه خون بیمار انتخاب نشده است.'
    };

    shouldComponentUpdate (nextProps, nextState, nextContext) {
        const {state, props} = this;

        return state.action !== nextState.action ||
            state.error !== nextState.error ||
            state.loading !== nextState.loading ||
            state.fields !== nextState.fields ||
            state.patientFileInfo !== nextState.patientFileInfo ||
            props.base.sectionNormRequestFormPrintView !== nextProps.base.sectionNormRequestFormPrintView ||
            props.base.normInformalRequestFormPrintOnSubmit !== nextProps.base.normInformalRequestFormPrintOnSubmit;
    }

    componentDidMount () {

    }

    render () {
        const {state, props, ref} = this;
        const cities = [{id: '', text: '...'}];

        state.fields?.patientProvinceId && cities.push(...(state.fields?.patientProvinceId[0]?.cities || []));

        return <React.Fragment>
            <Modal ref={ref.modal}
                   name={'ModalSectionNormInformalRequest'}
                   size={'large'}
                   title={'فرم درخواست عادی از بانک خون'}
                   required={true}
                   error={this.state.error}
                   loading={this.state.loading}
                   onClose={this.props.onClose}>
                <ModalContent>
                    <div className={'dis-f'}>
                        <Label className={'fb-20'} size={'medium'}>مشخصات بیمار :</Label>
                        <Input ref={ref.patientFirstName} className={'pad-4 fb-2 fb-5x-4 fb-3x-8 fb-2x-20'} label={'نام'} validation={this.validations.patientFirstName} readOnly={!this.state.isNewPatient} value={state?.fields?.patientFirstName} onChange={this.setField.bind(this, 'patientFirstName')}/>
                        <Input ref={ref.patientLastName} className={'pad-4 fb-4 fb-5x-6 fb-3x-12 fb-2x-20'} label={'نام خانوادگی'} validation={this.validations.patientLastName} readOnly={!this.state.isNewPatient} value={state?.fields?.patientLastName} onChange={this.setField.bind(this, 'patientLastName')}/>
                        <Input ref={ref.patientFatherName} className={'pad-4 fb-3 fb-5x-4 fb-3x-8 fb-2x-20'} label={'نام پدر'} validation={this.validations.patientFatherName} readOnly={!this.state.isNewPatient} value={state?.fields?.patientFatherName} onChange={this.setField.bind(this, 'patientFatherName')}/>
                        <Date ref={ref.patientBirthDate} className={'pad-4 fb-4 fb-5x-6 fb-3x-12 fb-2x-20'} label={'تاریخ تولد'} max={moment()} validation={this.validations.patientBirthDate} readOnly={!this.state.isNewPatient} value={state?.fields?.patientBirthDate} onChange={this.setField.bind(this, 'patientBirthDate')}/>
                        <Input ref={ref.patientNationalCode} align={"center"} direction={"ltr"} className={'pad-4 fb-4 fb-5x-5 fb-3x-10 fb-2x-20'} type={"number"} label={'کدملی'} readOnly={!this.state.isNewPatient} value={state?.fields?.patientNationalCode} onChange={this.setField.bind(this, 'patientNationalCode')}/>
                        <ValidationSpot ref={ref.patientGenderId} label={'جنسیت'} className={'dis-f pad-4 fb-3 fb-5x-5 fb-3x-10 fb-2x-20'} style={{flexDirection: 'column'}} validation={this.validations.patientGenderId} readOnly={!this.state.isNewPatient}>
                            <Label size={'small'}>جنسیت</Label>
                            <div className={'dis-f'}>
                                <div className={'pad-h-4'}>
                                    <Radio label={'مرد'} name={'patientGenderId'} checked={state?.fields?.patientGenderId == 1} onClick={this.setField.bind(this, 'patientGenderId', 1)}/>
                                </div>
                                <div className={'pad-h-4'}>
                                    <Radio label={'زن'} name={'patientGenderId'} checked={state?.fields?.patientGenderId == 2} onClick={this.setField.bind(this, 'patientGenderId', 2)}/>
                                </div>
                            </div>
                        </ValidationSpot>
                        <Select ref={ref.patientProvinceId} className={'pad-4 fb-4 fb-5x-5 fb-3x-10 fb-2x-20'} label={'استان'} options={state.provinces} validation={this.validations.patientProvinceId} readOnly={!this.state.isNewPatient} value={state?.fields?.patientProvinceId} onChange={this.setField.bind(this, 'patientProvinceId')}/>
                        <Select ref={ref.patientCityId} className={'pad-4 fb-4 fb-5x-5 fb-3x-10 fb-2x-20'} label={'شهر'} options={cities} validation={this.validations.patientCityId} readOnly={!this.state.isNewPatient} value={state?.fields?.patientCityId} onChange={this.setField.bind(this, 'patientCityId')}/>
                        <Input className={'pad-4 fb-4 fb-5x-5 fb-3x-10 fb-2x-20'} label={'بیمارستان'} readOnly={true} value={props.user?.hospitalFullName}/>
                        <Select ref={ref.sectionId} className={'pad-4 fb-4 fb-5x-5 fb-3x-10 fb-2x-20'} label={'بخش'} options={state.sections} validation={this.validations.sectionId} value={state?.fields?.sectionId} onChange={this.setField.bind(this, 'sectionId')}/>
                        {/*<Input ref={ref.patientFileCode} className={'pad-4 fb-4 fb-5x-5 fb-3x-20'} label={'شماره پرونده'} validation={this.validations.patientFileCode} value={state?.fields?.patientFileCode} onChange={this.setField.bind(this, 'patientFileCode')} onBlur={this.patientFileCodeSubmitHandler.bind(this)} onEnter={this.patientFileCodeSubmitHandler.bind(this)}/>*/}
                        <InputButton ref={ref.patientFileCode} className={'pad-4 fb-4 fb-5x-5 fb-3x-20'} label={'شماره پرونده'} validation={this.validations.patientFileCode} value={state?.fields?.patientFileCode} onChange={this.setField.bind(this, 'patientFileCode')} buttonTitle={'جستجو'} onButtonClick={this.patientFileCodeSubmitHandler.bind(this)} onEnter={this.patientFileCodeSubmitHandler.bind(this)}/>
                        <Separator/>
                        <div className={'fb-20 dis-f'}>
                            <Label className={'fb-20'}>فرآورده‌های درخواستی :</Label>
                            <ValidationSpot ref={ref.products} label={'فرآورده‌های درخواستی'} validation={this.validations.products} className={'dis-f fb-20'}>
                                <div className={'dis-f pad-4 fb-10 fb-5x-20'}>
                                    <Check className={'fb-17 fb-2x-20'} label={'گلبول قرمز متراکم Red Blood Cells'} checked={this.isChecked(state?.fields?.rbccount)} onChange={this.setField.bind(this, 'rbccount')}/>
                                    <Input ref={ref.rbccount} type={'number'} disabled={!this.isChecked(state?.fields?.rbccount)} className={'fb-3 fb-2x-20'} placeholder={'تعداد'} align={'center'} dir={'ltr'} validation={this.validations.rbccount} value={state?.fields?.rbccount || ''} onChange={this.setField.bind(this, 'rbccount')}/>
                                </div>
                                <div className={'dis-f pad-4 fb-10 fb-5x-20'}>
                                    <Check className={'fb-17 fb-2x-20'} label={'خون کامل Whole Blood (WB)'} checked={this.isChecked(state?.fields?.wbcount)} onChange={this.setField.bind(this, 'wbcount')}/>
                                    <Input ref={ref.wbcount} type={'number'} disabled={!this.isChecked(state?.fields?.wbcount)} className={'fb-3 fb-2x-20'} placeholder={'تعداد'} align={'center'} dir={'ltr'} validation={this.validations.wbcount} value={state?.fields?.wbcount || ''} onChange={this.setField.bind(this, 'wbcount')}/>
                                </div>
                                <div className={'dis-f pad-4 fb-10 fb-5x-20'}>
                                    <Check className={'fb-17 fb-2x-20'} label={'گلبول قرمز کم لکوسیت leukoreduced RBC'} checked={this.isChecked(state?.fields?.lrbccount)} onChange={this.setField.bind(this, 'lrbccount')}/>
                                    <Input ref={ref.lrbccount} type={'number'} disabled={!this.isChecked(state?.fields?.lrbccount)} className={'fb-3 fb-2x-20'} placeholder={'تعداد'} align={'center'} dir={'ltr'} validation={this.validations.lrbccount} value={state?.fields?.lrbccount || ''} onChange={this.setField.bind(this, 'lrbccount')}/>
                                </div>
                                <div className={'dis-f pad-4 fb-10 fb-5x-20'}>
                                    <Check className={'fb-17 fb-2x-20'} label={'پلاسمای تازه منجمد Fresh Frozen Plasma (FFP)'} checked={this.isChecked(state?.fields?.ffpcount)} onChange={this.setField.bind(this, 'ffpcount')}/>
                                    <Input ref={ref.ffpcount} type={'number'} disabled={!this.isChecked(state?.fields?.ffpcount)} className={'fb-3 fb-2x-20'} placeholder={'تعداد'} align={'center'} dir={'ltr'} validation={this.validations.ffpcount} value={state?.fields?.ffpcount || ''} onChange={this.setField.bind(this, 'ffpcount')}/>
                                </div>
                                <div className={'dis-f pad-4 fb-10 fb-5x-20'}>
                                    <Check className={'fb-17 fb-2x-20'} label={'کیسه خون اطفال'} checked={this.isChecked(state?.fields?.pediatricCount)} onChange={this.setField.bind(this, 'pediatricCount')}/>
                                    <Input ref={ref.pediatricCount} type={'number'} disabled={!this.isChecked(state?.fields?.pediatricCount)} className={'fb-3 fb-2x-20'} placeholder={'تعداد'} align={'center'} dir={'ltr'} validation={this.validations.pediatricCount} value={state?.fields?.pediatricCount || ''} onChange={this.setField.bind(this, 'pediatricCount')}/>
                                </div>
                                <div className={'dis-f pad-4 fb-10 fb-5x-20'}>
                                    <Check className={'fb-17 fb-2x-20'} label={'رسوب کرایو CryoPrecipitate (AHF)'} checked={this.isChecked(state?.fields?.crycount)} onChange={this.setField.bind(this, 'crycount')}/>
                                    <Input ref={ref.crycount} type={'number'} disabled={!this.isChecked(state?.fields?.crycount)} className={'fb-3 fb-2x-20'} placeholder={'تعداد'} align={'center'} dir={'ltr'} validation={this.validations.crycount} value={state?.fields?.crycount || ''} onChange={this.setField.bind(this, 'crycount')}/>
                                </div>
                                <div className={'dis-f pad-4 fb-10 fb-5x-20'}>
                                    <Check className={'fb-17 fb-2x-20'} label={'گلبول قرمز شسته شده'} checked={this.isChecked(state?.fields?.washedRbccount)} onChange={this.setField.bind(this, 'washedRbccount')}/>
                                    <Input ref={ref.washedRbccount} type={'number'} disabled={!this.isChecked(state?.fields?.washedRbccount)} className={'fb-3 fb-3x-10 fb-2x-20'} placeholder={'تعداد'} align={'center'} dir={'ltr'} validation={this.validations.washedRbccount} value={state?.fields?.washedRbccount || ''} onChange={this.setField.bind(this, 'washedRbccount')}/>
                                </div>
                                <div className={'dis-f pad-4 fb-10 fb-5x-20'}>
                                    <Check className={'fb-17 fb-2x-20'} label={'پلاسمای فاقد کرایو Cryo Poor Plasma (CPP)'} checked={this.isChecked(state?.fields?.cppcount)} onChange={this.setField.bind(this, 'cppcount')}/>
                                    <Input ref={ref.cppcount} type={'number'} disabled={!this.isChecked(state?.fields?.cppcount)} className={'fb-3 fb-2x-20'} placeholder={'تعداد'} align={'center'} dir={'ltr'} validation={this.validations.cppcount} value={state?.fields?.cppcount || ''} onChange={this.setField.bind(this, 'cppcount')}/>
                                </div>
                                <div className={'dis-f pad-4 fb-10 fb-5x-20'}>
                                    <Check className={'fb-13 fb-3x-20'} label={'سایر فرآورده‌ها / فرآورده با ویژگی خاص'} checked={this.isChecked(state?.fields?.otherProductsCount)} onChange={this.setField.bind(this, 'otherProductsCount')}/>
                                    <Input ref={ref.otherProductsName} disabled={!this.isChecked(state?.fields?.otherProductsCount)} className={'fb-4 fb-3x-10 fb-2x-20 pad-e-8 pad-2x-e-0 pad-2x-b-8'} placeholder={'نام فرآورده'} align={'center'} dir={'ltr'} validation={this.validations.otherProductsName} value={state?.fields?.otherProductsName} onChange={this.setField.bind(this, 'otherProductsName')}/>
                                    <Input ref={ref.otherProductsCount} type={'number'} disabled={!this.isChecked(state?.fields?.otherProductsCount)} className={'fb-3 fb-3x-10 fb-2x-20'} placeholder={'تعداد'} align={'center'} dir={'ltr'} validation={this.validations.otherProductsCount} value={state?.fields?.otherProductsCount || ''} onChange={this.setField.bind(this, 'otherProductsCount')}/>
                                </div>
                                <div className={'dis-f pad-4 fb-10 fb-5x-20'}>
                                    <Check className={'fb-17 fb-2x-20'} label={'پلاکت Platelet (PLT)'} checked={this.isChecked(state?.fields?.pltcount)} onChange={this.setField.bind(this, 'pltcount')}/>
                                    <Input ref={ref.pltcount} type={'number'} disabled={!this.isChecked(state?.fields?.pltcount)} className={'fb-3 fb-2x-20'} placeholder={'تعداد'} align={'center'} dir={'ltr'} validation={this.validations.pltcount} value={state?.fields?.pltcount || ''} onChange={this.setField.bind(this, 'pltcount')}/>
                                </div>
                            </ValidationSpot>
                            {state?.fields?.ffpcount && <div className={'pad-4'} style={{color: 'var(--goo-red)', fontSize: 15}}>فرم مخصوص درخواست پلاسمای تازه فریز شده نیز باید تکمیل شود.</div>}
                        </div>
                        <Separator/>
                        <div className={'fb-15 fb-4x-20'}>
                            <Label>هدف از درخواست خون :</Label>
                            <ValidationSpot ref={ref.requestPurpose} label={'هدف درخواست'} validation={this.validations.requestPurpose} className={'dis-f fb-3x-20 dis-3x-b'}>
                                <Radio className={'pad-h-4'} label={'رزرو خون'} name={'requestPurpose'} checked={state?.fields?.requestPurpose == 1} onClick={this.setField.bind(this, 'requestPurpose', 1)}/>
                                <Radio className={'pad-h-4'} label={'آماده سازی خون جهت تزریق'} name={'requestPurpose'} checked={state?.fields?.requestPurpose == 2} onClick={this.setField.bind(this, 'requestPurpose', 2)}/>
                                <Radio className={'pad-h-4'} label={'تزریق پس از رزرو'} name={'requestPurpose'} checked={state?.fields?.requestPurpose == 3} onClick={this.setField.bind(this, 'requestPurpose', 3)}/>
                            </ValidationSpot>
                        </div>
                        <div className={'fb-5 fb-4x-10 fb-3x-20'}>
                            <Select ref={ref.patientBloodGroupId} className={'fb-20'} label={'گروه خون نمونه خون بیمار'} options={state.bloodGroups} value={state.fields?.patientBloodGroupId} validation={this.validations.patientBloodGroupId} onChange={this.setField.bind(this, 'patientBloodGroupId')}/>
                            {state.history.length ? <Label style={{color: 'var(--goo-yel)'}}>گروه خونی ثبت شده در سامانه: {state.history[0]?.patientBlodGroupStr}</Label> : ''}
                        </div>
                    </div>
                </ModalContent>
                <ModalControls>
                    <div className="flex"/>
                    {state.action === ModalAction.INSERT && <React.Fragment>
                        {/*<Check className={'mar-4'} label={'چاپ خودکار'} checked={props.base.normInformalRequestFormPrintOnSubmit} onChange={this.requestPrintOnSubmit.bind(this)}/>*/}
                        <Button refer={ref.insert} className={'mar-4'} theme={'blue'} onClick={this.insertClickHandler.bind(this)}>ثبت درخواست</Button>
                    </React.Fragment>}
                    <Button refer={ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
                </ModalControls>
            </Modal>
            <ModalPrint refer={this.ref.modalPrint}/>
        </React.Fragment>;
    }

    insertClickHandler () {
        const {ref, state} = this;

        if (this.validate()) {
            ref.insert.current.loading();
            this.setState({error: null});
            SectionNormRequest.informalInset({
                patientFirstName: state?.fields?.patientFirstName,
                patientLastName: state?.fields?.patientLastName,
                patientFatherName: state?.fields?.patientFatherName,
                patientBirthDate: state?.fields?.patientBirthDate.format('jYYYY-jMM-jDD'),
                patientNationalCode: state?.fields?.patientNationalCode?.toString() || null,
                patientGenderId: state?.fields?.patientGenderId,
                patientProvinceId: state?.fields?.patientProvinceId[0]?.id,
                patientCityId: state?.fields?.patientCityId[0]?.id,
                sectionId: state?.fields?.sectionId[0]?.id,
                patientFileCode: state?.fields?.patientFileCode,
                patientFileCodeId: state?.patientFileInfo?.patientFileCodeId || null,
                rbccount: state?.fields?.rbccount,
                wbcount: state?.fields?.wbcount,
                lrbccount: state?.fields?.lrbccount,
                ffpcount: state?.fields?.ffpcount,
                pediatricCount: state?.fields?.pediatricCount,
                crycount: state?.fields?.crycount,
                washedRbccount: state?.fields?.washedRbccount,
                cppcount: state?.fields?.cppcount,
                otherProductsCount: state?.fields?.otherProductsCount,
                otherProductsName: state?.fields?.otherProductsName,
                pltcount: state?.fields?.pltcount,
                requestPurpose: state?.fields?.requestPurpose,
                patientBloodGroupId: state?.fields?.patientBloodGroupId[0]?.id,
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.INSERT_SUCCESSFUL).show();
                ref.insert.current.loading(false);
                this.close(true);

                if (this.props.base.normInformalRequestFormPrintOnSubmit)
                    this.print(state?.fields);
            }).catch(message => {
                ref.insert.current.loading(false);
                this.setState({
                    error: message?.message || message,
                    history: message?.result || []
                });
                new Notif({message: message?.message || message, theme: 'error'}).show();
            });
        }
    }

    patientFileCodeSubmitHandler (value) {
        if (!value) {
            this.setState({patientFileInfo: undefined});
        }

        if (value) {
            this.setState({
                patientFileInfo: undefined,
                fields: {
                    ...this.state.fields,
                    patientFirstName: undefined,
                    patientLastName: undefined,
                    patientFatherName: undefined,
                    patientBirthDate: undefined,
                    patientNationalCode: undefined,
                    patientGenderId: undefined,
                    patientProvinceId: undefined,
                    patientCityId: undefined
                },
                isNewPatient: false,
                loading: 'در حال دریافت پرونده بیمار'
            });

            Patient.data({
                patientFileCode: value
            })
                .then(data => {
                    const cities = this.state.provinces.find(item => item.id == data?.patientProvinceId)?.cities || [];
                    const patient = {
                        patientFirstName: data.patientFirstName,
                        patientLastName: data.patientLastName,
                        patientFatherName: data.patientFatherName,
                        patientBirthDate: moment(data.patientBirthDate, 'jYYYY-jMM-jDD'),
                        patientNationalCode: data.patientNationalCode,
                        patientGenderId: data.patientGenderId,
                        patientProvinceId: [{id: data.patientProvinceId, cities}],
                        patientCityId: [{id: data.patientCityId}],
                    };

                    this.setState({
                        patientFileInfo: data,
                        isNewPatient: false,
                        fields: {
                            ...this.state.fields,
                            ...patient
                        },
                        loading: false
                    });
                })
                .catch(message => {
                    this.setState({
                        patientFileInfo: undefined,
                        isNewPatient: true,
                        loading: false
                    }, _ => {
                        this.ref.patientFirstName.current.focus();
                    });
                    new Notif({message, theme: 'error'}).show();
                });
        }
    }

    isChecked (value) {
        return value !== undefined && value !== false;
    }

    open (data, action) {
        if (action === ModalAction.INSERT) {
            this.setState({
                data,
                action,
                fields: {
                    sectionId: [{id: this.props.user.sectionId}]
                },
                history: [],
                patientFileInfo: undefined,
                error: null
            });
        }

        this.ref.modal.current.open()
            .then(_ => {
                if (action === ModalAction.INSERT) {
                    this.ref.patientFileCode.current.focus();
                }
            });
    }

    close (success) {
        this.ref.modal.current.close();

        if (success === true)
            this.props.onSuccess();

        this.props.onClose();
    }

    fieldWillUpdate (keys, value, currentFields, nextFields) {
        const {ref} = this;

        switch (keys[0]) {
            case 'patientGenderId':
            case 'requestPurpose':
                ref[keys[0]].current.validate(value);
                break;
            case 'patientProvinceId':
                delete nextFields.patientCityId;
                break;
            case 'rbccount':
            case 'lrbccount':
            case 'wbcount':
            case 'ffpcount':
            case 'crycount':
            case 'cppcount':
            case 'pltcount':
            case 'pediatricCount':
            case 'washedRbccount':
                if (value === true)
                    value = 1;
                else if (value === false) {
                    ref[keys[0]].current.error(false);
                }
                nextFields[keys[0]] = value;
                ref.products.current.validate(nextFields);
                break;
            case 'otherProductsCount':
                if (value === true)
                    value = 1;
                else if (value === false) {
                    delete nextFields.otherProductsName;
                    ref.otherProductsCount.current.error(false);
                    ref.otherProductsName.current.error(false);
                }
                nextFields[keys[0]] = value;
                ref.products.current.validate(nextFields);
                break;
            default:
        }
    }

    updateCities (patientProvinceId, ret = false) {
        patientProvinceId = patientProvinceId[0]?.id;
        const province = this.state.provinces.find(item => item.id == patientProvinceId);

        const cities = [
            {id: '', text: '...'},
            ...(province.cities || []).map(item => {
                return {id: item.cityId, text: item.cityName};
            })
        ];

        if (!ret)
            this.setState({cities});
        else
            return cities;
    }

    requestPrintOnSubmit (value) {
        this.props.updateBase({normInformalRequestFormPrintOnSubmit: value});
    }

    print (data = null) {
        this.ref.modalPrint.current.open({
            title: 'چاپ',
            prints: [{
                id: 'sectionNormRequestForm',
                title: 'چاپ فرم درخواست',
                count: 1,
                template: printerTemplate.INSERT_NORM_REQUEST,
                parameters: {
                    PatientFirstName: data?.patientFirstName,
                    PatientLastName: data?.patientLastName,
                    PatientFatherName: data?.patientFatherName,
                    PatientBirthDate: data?.patientBirthDate,
                    PatientNationalCode: data?.patientNationalCode,
                    PatientGenderId: data?.patientGenderId,
                    PatientProvinceStr: data?.patientProvinceId[0]?.text,
                    PatientCityStr: data?.patientCityId[0]?.text,
                    HospitalNameStr: this.props.user?.hospitalFullName || '-',
                    SectionStr: data?.sectionId[0]?.text,
                    PatientFileCode: data?.patientFileCode,
                    PatientBloodGroupStr: (data?.patientBloodGroupId || [])[0]?.text,
                    Rbccount: data?.rbccount,
                    Lrbccount: data?.lrbccount,
                    PediatricCount: data?.pediatricCount,
                    WashedRbccount: data?.washedRbccount,
                    OtherProductsCount: data?.otherProductsCount,
                    OtherProductsName: data?.otherProductsName,
                    Wbcount: data?.wbcount,
                    Ffpcount: data?.ffpcount,
                    Crycount: data?.crycount,
                    Cppcount: data?.cppcount,
                    Pltcount: data?.pltcount,
                    RequestPurpose: data?.requestPurpose
                }
            }, {
                id: 'normRequestSamplingLabel',
                title: 'چاپ برچسب نمونه گیری',
                count: 1,
                template: printerTemplate.NORM_REQUEST_SAMPLING_LABEL,
                parameters: {
                    PFullName: `${data?.patientFirstName} ${data?.patientLastName}`,
                    PFileCodeStr: data?.patientFileCode,
                    SamplingDateTime: data?.bloodSamplingDate.format('jYYYY/jMM/jDD HH:mm'),
                    SamplerFullName: `${data?.samplerName} ${data?.samplerLastName}`
                }
            }]
        });
    }

    validate () {
        const {state, ref} = this;
        const validate = Tool.validate(ref.patientFirstName,
            ref.patientLastName,
            ref.patientFatherName,
            ref.patientBirthDate,
            ref.patientNationalCode,
            [ref.patientGenderId, state?.fields?.patientGenderId],
            ref.patientProvinceId,
            ref.patientCityId,
            ref.sectionId,
            ref.patientFileCode,
            [ref.products, state?.fields],
            ref.rbccount,
            ref.wbcount,
            ref.lrbccount,
            ref.ffpcount,
            ref.pediatricCount,
            ref.crycount,
            ref.washedRbccount,
            ref.cppcount,
            ref.otherProductsName,
            ref.otherProductsCount,
            ref.pltcount,
            [ref.requestPurpose, state?.fields?.requestPurpose],
            ref.patientBloodGroupId
        );

        if (validate !== true)
            new Notif({message: validate.message, theme: 'error'}).show();

        return validate === true;
    }
}

const mapStateToProps = state => {
    return {
        base: state.base,
        user: state.user
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateBase: props => dispatch(updateBase(props))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalSectionNormInformalRequest);